import { createContext } from 'react';

export type FirebaseRegisterFunction = () => Promise<[permission: NotificationPermission, token?: string]>;

export interface FirebaseContextProps {
    token?: string;
    isLoading: boolean;
    registerFirebaseToken: FirebaseRegisterFunction;
}

export const FirebaseContext = createContext<Partial<FirebaseContextProps>>({});
